import { Card, Descriptions, Space, Tag } from 'antd'
import { useTranslation } from 'react-i18next'

import type { FulfillmentOrderRoot } from '@repo/sdk'

import { StatusBadge } from '../../components/StatusBadge'
import { useFoDisplayStatusConfig } from './foDisplayStatusConfig'
import { FoAnnotationBadge } from './FoAnnotationBadge'
import { formatFoContext } from './orderDisplay'

interface OrderInfoCardProps {
  order: FulfillmentOrderRoot
}

export function OrderInfoCard({ order }: OrderInfoCardProps) {
  const { t } = useTranslation()
  const statusConfig = useFoDisplayStatusConfig()

  return (
    <Card title={t('pages.orders.sections.orderInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.orders.fields.orderDateTime')}>
          {formatFoContext(order, t)}
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.orders.fields.status')}>
          <Space>
            <StatusBadge status={order.displayStatus} configMap={statusConfig} />
            <FoAnnotationBadge annotation={order.annotation} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t('pages.orders.fields.composition')}>
          <Space size={4} wrap>
            <Tag>{t('pages.orders.compositionTotal', { count: order.summary.total })}</Tag>
            <Tag color="blue">
              {t('pages.orders.compositionActive', { count: order.summary.active })}
            </Tag>
            {order.summary.cancelled > 0 && (
              <Tag color="red">
                {t('pages.orders.compositionCancelled', { count: order.summary.cancelled })}
              </Tag>
            )}
            {order.summary.returned > 0 && (
              <Tag color="volcano">
                {t('pages.orders.compositionReturned', { count: order.summary.returned })}
              </Tag>
            )}
          </Space>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
